import { Box, Stack, Typography } from "@mui/material";

import { signOut } from "aws-amplify/auth";

import LanguageIcon from "@mui/icons-material/Language";
import { useDispatch } from "react-redux";
import { logout, setSignInStep } from "@store/slices/sessionSlice";

import { AppButton } from "@components/v2/AppButton";
import { primaryButtonSx } from "./loginStyles";

interface FormularioCuentaBloqueadaProps {}

export const FormularioCuentaBloqueada = (props: FormularioCuentaBloqueadaProps) => {
    const dispatch = useDispatch();

    return (
        <Stack direction={"column"} sx={{ gap: 2.5, alignItems: "center", textAlign: "center" }}>
            <Typography
                sx={{
                    fontFamily: "'Outfit', system-ui, sans-serif",
                    fontSize: "30px",
                    fontWeight: 600,
                    letterSpacing: "-0.02em",
                    color: "text.primary",
                }}>
                Lo sentimos
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column", gap: 1.5 }}>
                <Typography sx={{ fontSize: "15px", color: "text.secondary" }}>
                    Tu cuenta ha sido bloqueada ya que has llegado al máximo número de intentos para ingresar el código
                    de autenticación
                </Typography>
                <Typography sx={{ color: "secondary.main", fontWeight: 700 }}>
                    {localStorage.getItem("email") ?? ""}
                </Typography>
                <Typography sx={{ color: "text.primary", mt: 1.5 }}>
                    Para desbloquear tu cuenta contacta a soporte:
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
                    <LanguageIcon sx={{ color: "text.primary" }} />
                    <Typography sx={{ color: "text.primary" }}>contacto@lendia.mx</Typography>
                </Box>
            </Box>
            <AppButton
                tone="navy"
                size="large"
                sx={{ ...primaryButtonSx, width: "auto", px: 4 }}
                onClick={async () => {
                    await signOut();
                    dispatch(logout());
                    dispatch(setSignInStep(""));
                }}
            >
                Regresar
            </AppButton>
        </Stack>
    );
};
